import { CINEMA_NAMES } from 'global/helpers/cinemaList'
import ButtonCinestar from '../../../../../Buttons/ButtonCinestar/ButtonCinestar'

import './ChooseCinemaBtn.scss'

const ChooseCinemaBtn = ({ onCinema, openedChooseCinema, isCounting, chosenCinema }) => {
    const cinemaName = CINEMA_NAMES.find((cinema) => cinema.slug === chosenCinema)?.name
    return (
        <>
            <ButtonCinestar
                variant={'secondary'}
                iconRight={openedChooseCinema ? 'chevron–up' : 'chevron–down'}
                className={`choose-cinema-mobile border-0 py-0 ${isCounting && 'd-none'}`}
                onClick={onCinema}
            >
                {cinemaName}
            </ButtonCinestar>

            <ButtonCinestar
                variant={'secondary'}
                iconRight={openedChooseCinema ? 'chevron–up' : 'chevron–down'}
                className={'choose-cinema-nonmobile border-0 py-0'}
                onClick={onCinema}
            >
                {cinemaName}
            </ButtonCinestar>
        </>
    )
}

export default ChooseCinemaBtn
